import { Url } from "../../../constants/ApiUrlConstants";

export const DownloadExcel = async (id, year, period, name) => {

  const dept = [
    "HR",
    "Governance",
    "IT",
    "Facility"
  ]
  try {
    let token = sessionStorage.getItem('TOKEN')
    const response = await fetch(Url.downloadObservationExcelStream.replace('{deptId}', id).replace("{auditYear}", year).replace("{auditPeriod}", period), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        "Authorization": "Bearer " + token,
        'X-CSRF-TOKEN': 'YmUyYjAzODItOGIyZi00Njk1LThhOGMtYjhkYzVmZDY0YjI2'
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const excelBlob = await response.blob();

    // Create a download link
    const url = window.URL.createObjectURL(excelBlob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${dept[id-1]}_${year}_${period}.xlsx`;
    link.click();
  } catch (error) {
    console.error('Error downloading .xlsx file:', error);
  }
};